<template>
  <el-form ref="ruleForm" :model="form" class="articleForm">
    <el-form-item
      prop="attachCode"
      :rules="[
        {
          required: true,
          message: '稿件附件必须上传',
          trigger: 'change',
        },
      ]"
    >
      <el-upload drag v-model="form.attachCode" :action="uploadURL" :before-upload="uploadBefore" ref="fileUpload" :multiple="false" name="file" list-type="text" :file-list="uploadFilelist" :limit="1" :headers="uploadHeaders" :on-exceed="uploadExceed" :on-success="uploadSuccess" :on-remove="uploadRemove" accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传docx文件，且不超过50MB</div>
      </el-upload>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submit">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import authorApi from "@/api/author"
import http from "@/api/http"
import { getToken } from "@/utils/auth"
export default {
  name: "FormArticleUpload",
  props: {
    articleId: {
      type: Number,
      require: true,
    },
  },

  data() {
    return {
      form: {
        attachId: 0,
        attachCode: "",
      },
      uploadFilelist: [],
      uploadURL: "",
      uploadHeaders: { Authorization: getToken() },
      status: 0,
      uploadFlag: false,
    }
  },

  created() {
    this.uploadURL = http.defaults.baseURL + "attach/uploadArticle"
  },

  methods: {
    uploadBefore(file) {
      //const isDOC = file.type === "application/msword"
      const isDOCX = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      const isLt5M = file.size / 1024 / 1024 < 50

      if (!isDOCX) {
        this.$alert("上传文件必须是DOCX 格式!", "系统提示", {
          confirmButtonText: "确定",
        })
        return false
      }
      if (!isLt5M) {
        this.$alert("上传文件不能超过 50MB!", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      return isDOCX && isLt5M
    },

    uploadExceed() {
      this.$alert("只能上传一个文件，请删除后再上传", "异常提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
    },

    uploadSuccess(res) {
      if (res.code == 1) {
        this.$alert("上传失败,请重新上传", "异常提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
        this.$refs.fileUpload.clearFiles()
      } else {
        this.uploadFlag = true
        this.form.attachId = res.data.attachId
        this.form.attachCode = res.data.attachCode
        this.$refs.ruleForm.validateField("attachCode")
      }
    },

    uploadRemove() {
      authorApi.myArticleRemoveFile(this.form.attachId, this.form.attachCode).then((res) => {
        console.log(res)
      })
    },

    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          authorApi.reviseArticle(this.articleId, this.form.attachId, this.form.attachCode).then((res) => {
            if (res.code == 0) {
              this.$notify({
                title: "成功",
                message: res.msg,
                type: "success",
              })
              this.$emit("articleUploadSuccess")
            } else {
              this.$notify.error({
                title: "错误",
                message: res.msg,
              })
            }
          })
        }
      })
    },
  },
}
</script>


<style scoped>
.articleForm >>> .el-upload {
  display: block;
}
</style>
